import { Button } from "@chakra-ui/button";
import { Flex } from "@chakra-ui/layout";
import React from "react";
import useComments from "../hooks/useComments";

export interface TabSwitcherProps {
  tabItems: string[];
  onTabClick: (index: number) => void;
  activeIndex?: number;
}

function TabSwitcher(props: TabSwitcherProps) {
  const { tabItems, onTabClick, activeIndex = 0 } = props;
  const { fetchComments } = useComments();
  const [tabIndex, setTabIndex] = React.useState(activeIndex);

  const handleButtonClick = (index: number, tabItems: string[]) => {
    onTabClick(index);
    setTabIndex(index);
    if (tabItems[index] === "Discussion") {
      fetchComments();
    }
  };

  return (
    <Flex
      width="full"
      justifyContent="flex-start"
      borderBottom="1px"
      borderColor="gray.200"
      marginTop={4}
      h="50"
    >
      {tabItems.map((item, index) => {
        return (
          item && (
            <Button
              fontSize="sm"
              variant="link"
              borderBottom={index === tabIndex ? "2px" : "none"}
              borderColor="brand.300"
              borderRadius="none"
              padding="0, 1rem, 6, 1rem"
              _hover={{ textDecor: "underline" }}
              onClick={() => handleButtonClick(index, tabItems)}
              key={item}
            >
              {item}
            </Button>
          )
        );
      })}
    </Flex>
  );
}

export default TabSwitcher;
